import React from 'react';
import QuizSidebox from '../../components/QuizSidebox/QuizSidebox';
import RegisterForm from './RegisterForm';
import "./Login.css";

function Register() {
	return (
		<div className="login">
			<QuizSidebox title="intellADAPT" variant="full" />
			<div className="quiz__main">
				<RegisterForm />
			</div>
		</div>
	);
}

export default Register;
